import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

import type { SearchClassification } from "@shared/types/SearchClassification";

interface SearchClassificationGuidanceParams {
  classificationId: number;
  classificationType: string;
  classificationTypeTableName: string;
  query: string;
}

export class SearchClassificationGuidanceEntity extends BaseEntityClass {
  classification_id: number;
  classification_type: string;
  classification_type_table_name: string;
  query: string;

  constructor(params: SearchClassificationGuidanceParams) {
    super();
    this.type = "search_classification_guidance";
    this.entity_version = 2;
    this.classification_id = params.classificationId;
    this.classification_type = params.classificationType;
    this.classification_type_table_name = params.classificationTypeTableName;
    this.query = params.query;
  }

  static fromSearchClassificationAndQuery(
    searchClassification: SearchClassification,
    searchQuery: string,
  ) {
    return new SearchClassificationGuidanceEntity({
      classificationId: searchClassification.id,
      classificationType: searchClassification.type,
      classificationTypeTableName: searchClassification.table_name,
      query: searchQuery,
    });
  }
}
